(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ms-multi-presentacion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-multi-presentacion')) {
    customElements.define(
      'ms-multi-presentacion',
      class MsMultiPresentacion extends HTMLElement {
        connectedCallback() {
          if (this.listo) return;
          this.listo = true;
          this.scope = this.closest('.product-details') || this.closest('.shopify-section');
          this.section = this.closest('.shopify-section');
          if (!this.scope) return;

          this.principal = (this.dataset.principal || '').trim().toLowerCase();
          this.ayuda = this.dataset.ayuda || '';
          this.txtBoton = this.dataset.boton || 'Agregar [n] al carrito · [total]';
          this.sumadas = [];
          this.pasar = false;
          try {
            const datos = JSON.parse(this.querySelector('[data-ms-mp-variantes]')?.textContent || '[]');
            this.variantes = new Map(datos.map((v) => [String(v.id), v]));
          } catch {
            this.variantes = new Map();
          }
          this.marcas = this.querySelector('[data-ms-mp-marcas]');

          this.alClic = this.alClic.bind(this);
          this.alEnviar = this.alEnviar.bind(this);
          // Captura en window: corre antes que variant-picker y la delegación de Horizon.
          window.addEventListener('click', this.alClic, true);
          window.addEventListener('submit', this.alEnviar, true);
          document.addEventListener('change', (e) => {
            if (e.target instanceof HTMLInputElement && e.target.name === 'quantity') this.pintar();
          });
          document.addEventListener('click', (e) => {
            if (e.target instanceof Element && e.target.closest('quantity-selector-component')) {
              requestAnimationFrame(() => this.pintar());
            }
          });

          this.observador = new MutationObserver(() => {
            if (this.pintando) return;
            this.pintar();
          });
          this.observador.observe(this.scope, { childList: true, subtree: true });
          this.pintar();
        }

        disconnectedCallback() {
          this.observador?.disconnect();
          window.removeEventListener('click', this.alClic, true);
          window.removeEventListener('submit', this.alEnviar, true);
        }

        // ── Lectura del selector ─────────────────────────────────────────
        tarjetas() {
          return Array.from(this.scope.querySelectorAll('variant-picker .variant-option__button-label'));
        }

        grupoDe(label) {
          let el = label.previousElementSibling;
          while (el && !el.classList.contains('ms-vg__titulo')) el = el.previousElementSibling;
          return el ? el.textContent.trim().toLowerCase() : '';
        }

        esSuma(label) {
          const g = this.grupoDe(label);
          return Boolean(g) && g !== this.principal;
        }

        idDe(label) {
          return label.querySelector('input')?.dataset.variantId || '';
        }

        /** La elegida ANTES del toque. El <input> cubre la tarjeta y llega al clic ya
         *  marcado (pre-activación); variant-picker.js mueve data-current-checked
         *  hasta el «change», así que ése dice cuál era. */
        principalId() {
          const picker = this.scope.querySelector('variant-picker');
          const input =
            picker?.querySelector('input[data-current-checked="true"]') || picker?.querySelector('input:checked');
          return input?.dataset.variantId || '';
        }

        // ── Toques ───────────────────────────────────────────────────────
        alClic(e) {
          if (this.pasar) return;
          const t = e.target instanceof Element ? e.target : null;
          const label = t?.closest('.variant-option__button-label');
          if (!label || !this.scope.contains(label)) return;
          const id = this.idDe(label);
          if (!id) return;

          const main = this.principalId();
          const esMain = id === main;
          const suma = this.esSuma(label);

          // Tocar la que ya es la principal: si hay sumadas, se quita y sube la primera.
          if (esMain) {
            e.preventDefault();
            e.stopImmediatePropagation();
            if (this.sumadas.length) this.promover();
            return;
          }

          if (!suma) {
            // Cambio de tamaño normal. Si la principal era una sumable (crema sola),
            // no se pierde: pasa a sumada.
            const labelMain = this.tarjetas().find((l) => this.idDe(l) === main);
            if (labelMain && this.esSuma(labelMain) && !this.sumadas.includes(main)) this.sumadas.push(main);
            this.sumadas = this.sumadas.filter((x) => x !== id);
            requestAnimationFrame(() => this.pintar());
            return;
          }

          e.preventDefault();
          e.stopImmediatePropagation();
          const i = this.sumadas.indexOf(id);
          if (i > -1) this.sumadas.splice(i, 1);
          else if (this.variantes.get(id)?.a !== false) this.sumadas.push(id);
          this.pintar();
        }

        /** La principal se va; la primera sumada toma su lugar (cambio de variante real). */
        promover() {
          const id = this.sumadas.shift();
          const label = this.tarjetas().find((l) => this.idDe(l) === id);
          const input = label?.querySelector('input');
          if (!input) return this.pintar();
          this.pasar = true;
          input.click();
          this.pasar = false;
          this.pintar();
        }

        alEnviar(e) {
          const form = e.target;
          if (!(form instanceof HTMLFormElement) || !this.section?.contains(form)) return;
          if (!form.matches('form[action*="/cart/add"]')) return;
          this.escribirMarcas(this.cantidad(form));
        }

        cantidad(form) {
          const f = form || this.section?.querySelector('form[action*="/cart/add"]');
          return Math.max(1, parseInt(f?.querySelector('input[name="quantity"]')?.value, 10) || 1);
        }

        // ── Dibujar ──────────────────────────────────────────────────────
        pintar() {
          this.pintando = true;
          const main = this.principalId();
          this.sumadas = this.sumadas.filter((id) => id !== main && this.variantes.has(id));
          let ayudaPuesta = Boolean(this.scope.querySelector('.ms-mp__ayuda'));
          let primeraSuma = null;

          this.tarjetas().forEach((label) => {
            const suma = this.esSuma(label);
            const id = this.idDe(label);
            label.classList.toggle('ms-mp__suma', suma);
            const on = suma && this.sumadas.includes(id);
            if (label.classList.contains('ms-mp__sumada') !== on) label.classList.toggle('ms-mp__sumada', on);

            let insignia = label.querySelector('.ms-mp__insignia');
            if (suma && !insignia) {
              insignia = document.createElement('span');
              insignia.className = 'ms-mp__insignia';
              insignia.setAttribute('aria-hidden', 'true');
              insignia.innerHTML =
                '<svg class="ms-mp__mas" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>' +
                '<svg class="ms-mp__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
              label.append(insignia);
            } else if (!suma && insignia) insignia.remove();
            if (suma && !primeraSuma) primeraSuma = label;
          });

          // La ayuda va justo ANTES del título del primer grupo que se suma.
          if (this.ayuda && primeraSuma && !ayudaPuesta) {
            let titulo = primeraSuma.previousElementSibling;
            while (titulo && !titulo.classList.contains('ms-vg__titulo')) titulo = titulo.previousElementSibling;
            if (titulo) {
              const p = document.createElement('p');
              p.className = 'ms-mp__ayuda';
              p.textContent = this.ayuda;
              titulo.before(p);
            }
          }

          const plantillaEsc = this.querySelector('[data-ms-mp-escalera]');
          if (plantillaEsc && !this.scope.querySelector('.ms-mp__escalera')) {
            const esc = plantillaEsc.content.firstElementChild?.cloneNode(true);
            const ayudaNodo = this.scope.querySelector('.ms-mp__ayuda');
            const tamanos = this.tarjetas().filter((l) => !this.esSuma(l));
            if (esc && ayudaNodo) ayudaNodo.before(esc);
            else if (esc && tamanos.length) tamanos[tamanos.length - 1].after(esc);
          }

          this.escribirMarcas(this.cantidad());
          this.pintarBoton(main);
          this.pintando = false;
          this.observador?.takeRecords();
        }

        escribirMarcas(q) {
          if (!this.marcas) return;
          const html = this.sumadas
            .map((id) => `<span data-ms-addon data-variant-id="${id}" data-quantity="${q}"></span>`)
            .join('');
          if (this.marcas.innerHTML !== html) this.marcas.innerHTML = html;
        }

        pintarBoton(main) {
          const botones = [
            this.section?.querySelector('product-form-component [ref="addToCartButton"]'),
            ...document.querySelectorAll('[data-sticky-add-to-cart-button]'),
          ].filter(Boolean);
          const n = 1 + this.sumadas.length;
          const q = this.cantidad();
          const total = [main, ...this.sumadas].reduce((s, id) => s + (this.variantes.get(id)?.p || 0), 0) * q;

          botones.forEach((b) => {
            let span = b.querySelector('.add-to-cart-text__content');
            while (span && span.firstElementChild && span.firstElementChild.tagName === 'SPAN') span = span.firstElementChild;
            if (!span) return;
            if (!span.dataset.msMpOriginal) span.dataset.msMpOriginal = span.textContent.trim();
            // En la barra fija no cabe «Agregar 3 al carrito · $535 MXN»: va la corta.
            const enBarra = Boolean(b.closest('sticky-add-to-cart, [data-sticky-add-to-cart-button]'));
            const plantilla = enBarra ? 'Agregar [n] · [total]' : this.txtBoton;
            const texto =
              n > 1
                ? plantilla.replace('[n]', String(n)).replace('[total]', this.dinero(total).replace(/\s*MXN$/, enBarra ? '' : ' MXN').trim())
                : span.dataset.msMpOriginal;
            if (span.textContent.trim() !== texto) span.textContent = texto;
          });
        }

        dinero(cents) {
          const f = this.dataset.formato || '${{amount}}';
          const conCentavos = cents % 100 !== 0;
          const num = (cents / 100).toLocaleString('en-US', {
            minimumFractionDigits: conCentavos ? 2 : 0,
            maximumFractionDigits: 2,
          });
          // Pegado al símbolo, como ms-money y Theme.formatMoney («$475», no «$ 475»).
          return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, num).replace(/^(\D{1,3}?)\s+(?=\d)/, '$1');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ms-pdp-rating"] && !Shopify.designMode) return;
  try {
    /* El enlace de la calificación baja a las reseñas solo si existen en la página.
     El destino se resuelve al hacer clic (los widgets de app se inyectan tarde);
     si tres segundos después de cargar no hay a dónde ir, deja de ser enlace. */
  (function () {
    var CANDIDATOS = [
      '#ms-reviews',
      '#lmReview',
      '[id*="revie_reviews"]',
      '.jdgm-rev-widg',
      '#judgeme_product_reviews',
      '#looxReviews',
      '[class*="yotpo-reviews"]',
      '.yotpo-main-widget',
      '#stamped-main-widget',
      '.okeReviews-reviewsWidget',
      '#shopify-product-reviews'
    ];

    function destino(enlace) {
      var lista = [];
      var propio = enlace.getAttribute('href') || '';
      if (propio.charAt(0) === '#' && propio.length > 1) lista.push(propio);
      lista = lista.concat(CANDIDATOS);
      var primero = null;
      for (var i = 0; i < lista.length; i++) {
        var nodos;
        try { nodos = document.querySelectorAll(lista[i]); } catch (e) { continue; }
        for (var j = 0; j < nodos.length; j++) {
          if (enlace.contains(nodos[j])) continue;
          if (!primero) primero = nodos[j];
          // Un widget de app que aún no pinta mide 0: gana el que ya tiene caja.
          if (nodos[j].getBoundingClientRect().height > 0) return nodos[j];
        }
      }
      return primero;
    }

    function apagar(enlace) {
      enlace.removeAttribute('href');
      enlace.removeAttribute('data-ms-rating-link');
      var pista = enlace.querySelector('[data-ms-rating-link-hint]');
      if (pista) pista.remove();
    }

    document.addEventListener('click', function (evento) {
      var enlace = evento.target.closest ? evento.target.closest('[data-ms-rating-link]') : null;
      if (!enlace) return;
      evento.preventDefault();
      var objetivo = destino(enlace);
      if (!objetivo) { apagar(enlace); return; }
      var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      objetivo.scrollIntoView({ behavior: suave ? 'smooth' : 'auto', block: 'start' });
    });

    function revisar() {
      var enlaces = document.querySelectorAll('[data-ms-rating-link]');
      for (var i = 0; i < enlaces.length; i++) {
        if (!destino(enlaces[i])) apagar(enlaces[i]);
      }
    }

    if (!(window.Shopify && window.Shopify.designMode)) {
      window.addEventListener('load', function () { window.setTimeout(revisar, 3000); });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ms-presentation-art"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-presentation-art')) {
    customElements.define('ms-presentation-art', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.product-details');
        if (!this.scope) return;
        this.observer = new MutationObserver(() => this.apply());
        this.observer.observe(this.scope, {childList:true, subtree:true});
        this.apply();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      apply() {
        const map = Object.fromEntries(Array.from(this.querySelectorAll('[data-presentation]'), item => [item.dataset.presentation, item.dataset.image]));
        this.scope.querySelectorAll('.ms-vt__media').forEach(media => {
          const label = media.closest('label');
          const value = (label?.querySelector('input')?.value || label?.querySelector('.ms-vt__texto')?.textContent || '').toLowerCase().replace(/\s+/g,'');
          let key = value.replace(/ml$/,'');
          for (const [match, mapped] of [['desodorante','desodorante'],['crema','crema'],['rolete','rolete'],['roll-on','rolete'],['gel','gel'],['auto','auto'],['coche','auto'],['recarga','recarga']]) {
            if (value.includes(match)) key = mapped;
          }
          const url = map[key];
          if (!url) return;
          let img = media.querySelector('img');
          if (img?.getAttribute('src') === url && !img.hasAttribute('srcset')) return;
          if (!img) { img = document.createElement('img'); img.className = 'ms-vt__img'; media.replaceChildren(img); }
          img.removeAttribute('srcset'); img.removeAttribute('sizes');
          img.src = url; img.alt = ''; img.width = 64; img.height = 64; img.loading = 'lazy';
          media.classList.add('ms-vt__media--cutout');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["scroll-reveal-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scroll-reveal-timeline')) {
    class ScrollRevealTimeline extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-timeline-item]'));
        this.track = this.querySelector('[data-timeline-track]');
        this.icons = Array.from(this.querySelectorAll('.scroll-timeline__icon'));
        this.frame = null;
        this.update = this.update.bind(this);
        this.queueUpdate = this.queueUpdate.bind(this);
        window.addEventListener('scroll', this.queueUpdate, { passive: true });
        window.addEventListener('resize', this.queueUpdate, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.queueUpdate);
        window.removeEventListener('resize', this.queueUpdate);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      queueUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(this.update);
      }

      update() {
        this.frame = null;
        const viewportHeight = window.innerHeight;
        const clearLine = viewportHeight * 0.68;
        const fadeLine = viewportHeight * 0.94;
        const range = fadeLine - clearLine;

        this.items.forEach((item) => {
          const center = item.getBoundingClientRect().top + Math.min(item.offsetHeight * 0.25, 48);
          const progress = Math.max(0, Math.min(1, (fadeLine - center) / range));
          item.style.setProperty('--reveal-progress', progress.toFixed(3));
        });

        if (this.track && this.icons.length > 1) {
          const listRect = this.track.parentElement.getBoundingClientRect();
          const firstRect = this.icons[0].getBoundingClientRect();
          const lastRect = this.icons[this.icons.length - 1].getBoundingClientRect();
          const trackTop = firstRect.top + (firstRect.height / 2);
          const trackBottom = lastRect.top + (lastRect.height / 2);
          const trackHeight = Math.max(0, trackBottom - trackTop);
          const trackLeft = firstRect.left + (firstRect.width / 2);
          const progress = trackHeight > 0
            ? Math.max(0, Math.min(1, (clearLine - trackTop) / trackHeight))
            : 0;

          this.track.style.top = `${trackTop - listRect.top}px`;
          this.track.style.left = `${trackLeft - listRect.left - (this.track.offsetWidth / 2)}px`;
          this.track.style.height = `${trackHeight}px`;
          this.track.style.setProperty('--track-fill', progress.toFixed(3));
        }
      }
    }

    customElements.define('scroll-reveal-timeline', ScrollRevealTimeline);
  }
  } catch(e) { console.error(e); }
})();

})();
